// extracted by mini-css-extract-plugin
module.exports = {"root":"LabelledIcon_root__M3LEe","dropdownWrapper":"LabelledIcon_dropdownWrapper__5Jrhp","active":"LabelledIcon_active__wzLYS"};